// extracted by mini-css-extract-plugin
export var cols = "index-module--cols--eSfBU flexNoAlign section";
export var grey1 = "rgb(232, 232, 232)";
export var grey2 = "rgb(246, 246, 246)";
export var hw = "index-module--hw--2b4qt col";
export var hwCopy = "index-module--hwCopy--gezMx";
export var hwImg = "index-module--hwImg--TQvkz";
export var iconWrap = "index-module--iconWrap--fIc-P util-module--iconWrap--a7crv flex";
export var maxMd = "(max-width: 48em)";
export var movement = "index-module--movement--TQZXm index-module--fullWidth--jvj2O util-module--fullWidth--iiqEb util-module--brush--6CByv section";
export var movementBody = "index-module--movementBody--Komg6 flex";
export var movementImg = "index-module--movementImg--yBGIW";
export var screenshot = "index-module--screenshot--w0fNa";
export var ti = "index-module--ti--0EkaU flex section";
export var tiImgs = "index-module--tiImgs--1K5g3 col util-module--doubleImg--2e5kf";